module.exports = __webpack_public_path__ + "static/media/getting-support@2x.90bcf385.png";